import axios from "axios";
import { fetchAuthSession } from "aws-amplify/auth";

const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

client.interceptors.request.use(async (config) => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch {
    // No signed-in session — request goes out unauthenticated, guest-accessible endpoints handle this.
  }
  return config;
});

export default client;
